import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ProfileCompletionStatusApi = {
  fetchProfileCompletionStatus: async (userId) => {
    try {
      const response = await axiosInstance.get(
        Configs.profileCompletionStatusEp,
        {
          params: { user_id: userId },
        }
      );

      if (response.data.status === "success") {
        return response.data.data;
      } else {
        console.error("Error:", response.data.message);
        return null;
      }
    } catch (error) {
      console.error("An error occurred:", error);
      return null;
    }
  },
};

export default ProfileCompletionStatusApi;
